import React from "react";
import { Circle } from "../shape/circle";
import CloseIcon from "../icons/CloseIcon";

export function CloseButton({ onClick, style }) {
    return (
        <>
            <button
                className={"close-button"}
                aria-label="Loka"
                style={{
                    border: "none",
                    ...style,
                }}
                onClick={() => onClick()}
            >
                <CloseIcon
                    style={{
                        color: "white",
                        height: 30,
                        width: 30,
                        zIndex: 10,
                    }}
                />
            </button>
        </>
    );
}

export default CloseButton;
